// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"722":"8b6c1b5fbfd9fbdc","922":"8a1d2c4adfe04e08","3352":"e846b3523291c83e","4451":"018414aebd59c238","4792":"35c8afcc3bf170a9","7227":"8be9ed176b9f23ba","9309":"5eafc71e2915e10e"}[chunkId] + ".js";
};